import * as turf from '@turf/turf';
import { Feature, MultiPolygon, Polygon } from '@turf/turf';

/**
 * precision to meters
 * 6 - 0.11112
 * 5 - 1.1112
 * 4 - 11.112
 */
const laancSafeTruncatePrecision = 6;

export class FeatureUnioner {
    getUnion = (feature1: Feature<Polygon | MultiPolygon>, feature2: Feature<Polygon | MultiPolygon>): Feature<Polygon | MultiPolygon> => {
        if (!feature1 || !feature2){
            throw new Error('feature1 and feature2 are required ( or turf.union will return null and we need to change our return type)');
        }
        try {
            return turf.union(feature1, feature2) as Feature<Polygon | MultiPolygon>;
        } catch (err: any){
            return turf.union(this.truncate(feature1), this.truncate(feature2)) as Feature<Polygon | MultiPolygon>;
        }
    }
    truncate = (feature: Feature<Polygon | MultiPolygon>): Feature<Polygon | MultiPolygon> => {
        return turf.truncate(feature, { precision: laancSafeTruncatePrecision, mutate: false });
    }
}
